

export class NbasoftDeviceInfoRequest {
  operationId?: string;
  version?: number;
}
